import { NavigationItem } from "@/modules/common/features/navigation/model/types";
import {
  ContainerOutlined,
  FileDoneOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { DOCUMENT_REGISTER_LIST_PATH } from "@/modules/document-register/pages/document-register-list-page";
import { DOCUMENT_REGISTER_TYPE_LIST_PATH } from "@/modules/document-register/pages/document-register-type-list-page";
import { HR } from "@/shared/modules/constants/modules-id";
import { AllTokens } from "gql/graphql";

export const documentRegisterMenuItems: NavigationItem[] = [
  {
    label: "eDM",
    icon: <ContainerOutlined />,
    children: [
      {
        label: "e-documents",
        icon: <FileDoneOutlined />,
        to: DOCUMENT_REGISTER_LIST_PATH,
        requiredModule: HR,
        requiredAtLeastOnePermission: [AllTokens.DocumentsOrdersAccess],
      },
      {
        label: "e-documents templates",
        icon: <FileTextOutlined />,
        to: DOCUMENT_REGISTER_TYPE_LIST_PATH,
        requiredModule: HR,
        requiredAtLeastOnePermission: [AllTokens.DocumentsOrdersTypes],
      },
    ],
  },
];
